export const yearsOptions = () => {
  const currYear = new Date().getFullYear();
  const years = [];
  Array(121)
    .fill(0)
    .forEach((item, index) => {
      const newYear = currYear - index;
      years.push({ value: newYear.toString(), label: newYear.toString() });
    });
  return years.slice(18, 121);
};

export const monthOptions = [
  { value: "1", label: "January", days: 31 },
  { value: "2", label: "February", days: 28 },
  { value: "3", label: "March", days: 31 },
  { value: "4", label: "April", days: 30 },
  { value: "5", label: "May", days: 31 },
  { value: "6", label: "June", days: 30 },
  { value: "7", label: "July", days: 31 },
  { value: "8", label: "August", days: 31 },
  { value: "9", label: "September", days: 30 },
  { value: "10", label: "October", days: 31 },
  { value: "11", label: "November", days: 30 },
  { value: "12", label: "December", days: 31 },
];

export const isLeapYear = (year: number) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};
export const daysOptions = (month: string, year?: string) => {
  if (month) {
    const days =
      monthOptions[monthOptions.findIndex((option) => option.value === month)]
        .days;

    // Feb's day count depends on the year — only override when year is known
    const isFebruary = month === "2";
    const isLeap = year
      ? (parseInt(year) % 4 === 0 && parseInt(year) % 100 !== 0) ||
        parseInt(year) % 400 === 0
      : false;
    const totalDays = isFebruary && isLeap ? 29 : days;

    return Array(totalDays)
      .fill("")
      .map((item, index) => {
        const newDays = totalDays - index;
        return { value: newDays.toString(), label: newDays.toString() };
      })
      .reverse();
  } else {
    return [];
  }
};

export const minTwoDigits = (n: number) => {
  return (n < 10 ? "0" : "") + n;
};

//format yyyy-MM-dd
export const calculateAge = (ageString: string) => {
  if (!ageString) {
    return 0;
  } else {
    const splits = ageString.split("-");
    const birthday = new Date(
      parseInt(splits[0]),
      parseInt(splits[1]) - 1,
      parseInt(splits[2]),
    );
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs); // miliseconds from epoch
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return age;
  }
};

export function convertMsToTimeString(duration) {
  let minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
  return `${hours} ${hours === 1 ? "hr" : "hrs"} ${minutes} ${
    minutes === 1 ? "min" : "mins"
  }`;
}

//formats dates
export const dateFormmatter = (date) => {
  return new Date(date * 1000).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    weekday: "short",
    day: "numeric",
    year: "numeric",
  });
};
//formats dates without seconds
export const dateFormmatterNoSeconds = (date) => {
  return new Date(date * 1000).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    weekday: "short",
    day: "numeric",
    year: "numeric",
  });
};

//formats dates without seconds
export const dateFormmatterWithMonthNoSeconds = (date) => {
  return new Date(date * 1000).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
